export const partnerToOption = partner => ({
  label : partner?.values?.name,
  value : partner?.id,
})
